var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconBrokenLinkJqezpx9Sbr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb74d;}.cls-2{fill:#039be5;}.cls-3{fill:#ffe082;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "broken link marketing networking online") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "broken_link",
    "data-name": "broken link"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,19H7A6,6,0,0,1,7,7H17a6,6,0,0,1,0,12ZM7,9a4,4,0,0,0,0,8H17a4,4,0,0,0,0-8H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.5,28.86a1,1,0,0,1-.36-1.36l14-24a1,1,0,1,1,1.72,1l-14,24A1,1,0,0,1,8.5,28.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,13H15a6,6,0,0,0-6,6,6,6,0,0,0,6,6H25a6,6,0,0,0,0-12Zm0,10H15a3.89,3.89,0,0,1-1.7-.39,3.75,3.75,0,0,1-1.55-1.29A4,4,0,0,1,15,15H25a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.3,22.61l-1,1.74a5.89,5.89,0,0,1-1.6-1.2l1.07-1.83A3.75,3.75,0,0,0,13.3,22.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconBrokenLinkJqezpx9Sbr);
export default __webpack_public_path__ + "static/media/reshot-icon-broken-link-JQEZPX9SBR.24050b9eca5d1ab0c2352f25afa3b441.svg";
export { ForwardRef as ReactComponent };